require('./contractPayrollLoanDocumentsUpload.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @components
const PayrollLoanUploadHeader = require("../../contractPayrollLoan/payrollLoanUploadHeader/payrollLoanUploadHeader");
const { PrinterPreviewManager } = require('components/contactCenter/printer/printerPreviewManager');
const PayrollLoanRequestUpload = require('../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestUpload/payrollLoanRequestUpload');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

class ContractPayrollLoanDocumentsUpload extends React.Component {

    buildUploadHeader() {
        const { recordStatus } = this.props;
        return (
            <PayrollLoanUploadHeader recordStatus={recordStatus} />
        );
    }

    render() {
        const uploadHeader = this.buildUploadHeader();
        const {
            handlerEditFileName,
            immPayrollLoanRequest,
            loadFileInUpload,
            recordStatus,
            clearErrorsFile,
            removeUploadedFile
        } = this.props;

        return (
            <div className="payroll-loan-request-documents-upload">
                {uploadHeader}
                <div className="payroll-loan-request-documents-upload__body">
                    <PayrollLoanRequestUpload
                        clearErrorsFile={clearErrorsFile}
                        removeUploadedFile={removeUploadedFile}
                        immPayrollLoanRequest={immPayrollLoanRequest}
                        recordStatus={recordStatus}
                        loadFileInUpload={loadFileInUpload}
                        handlerEditFileName={handlerEditFileName}
                    />
                </div>
                <ContactCenterRender>
                    <PrinterPreviewManager />
                </ContactCenterRender>
            </div>
        );
    }
}

ContractPayrollLoanDocumentsUpload.propTypes = {
    handlerEditFileName: PropTypes.func.isRequired,
    recordStatus: PropTypes.string.isRequired,
    immPayrollLoanRequest: PropTypes.object.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired
};

module.exports = ContractPayrollLoanDocumentsUpload;
